import React from 'react'
// import Header from '@/components/header'
import './index.scss'
const HelpDetails = (props) => {
  console.log(props)
  return (
    <div className="help-details__box">
      {/* <Header tit="详情"/> */}
      <div className="help-text">
        详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情详情
      </div>
    </div>
  )
}
export default HelpDetails